import { DriverTour } from './outbox';

/** Stanje kupca sa stanice, kako ga server javi posle svakog slanja (K13). */
export interface StanjeKupca {
  id: number;
  /** Kupac ne zna da roba stiže — vidi `customerNotAnnounced`. */
  nenajavljen: boolean;
  phones: string[];
}

/**
 * Tura sa osveženim stanjem kupaca — ili `null` kad se ništa nije promenilo.
 *
 * Paket ture se učita pri polasku i radi bez mreže, pa se oznaka „kupac nije
 * obavešten" i telefoni kupaca posle toga ne menjaju sami. Analiza scenarija
 * (K13), 16.10.2026: najava koja propadne u podne, ili broj ispravljen u
 * ERP-u, do vozača nisu stizali do sledećeg učitavanja ture. Server zato uz
 * svaki odgovor na slanje kaže stanje kupaca, a telefon ga ovde prepisuje —
 * samo na kupčevim stanicama koje server zna; ostalo se ne dira.
 */
export function osveziKupce(tura: DriverTour, kupci: StanjeKupca[]): DriverTour | null {
  const poStanici = new Map(kupci.map((k) => [k.id, k]));
  let promena = false;

  const stops = tura.stops.map((s) => {
    const kupac = s.kind === 'CustomerAddress' ? poStanici.get(s.id) : undefined;
    if (!kupac) return s;

    const nenajavljen = Boolean(kupac.nenajavljen);
    const phones = Array.isArray(kupac.phones) ? kupac.phones : s.phones;

    if (Boolean(s.customerNotAnnounced) === nenajavljen
        && JSON.stringify(s.phones ?? []) === JSON.stringify(phones ?? [])) {
      return s;
    }

    promena = true;
    return { ...s, customerNotAnnounced: nenajavljen, phones };
  });

  return promena ? { ...tura, stops } : null;
}
